// React, Next
import { useTranslation } from 'next-i18next'

// MUI
import Box from '@mui/material/Box'

// Custom
import Section from '@/components/sections/Section'
import SectionHeader from '@/components/sections/SectionHeader'
import BulletGrid from '@/components/sections/BulletGrid'

// Style
import themeColors from 'assets/theme/colors'

export default function TakeawaysSection() {
  const { t } = useTranslation('servicesOtAwarenessTraining')

  const items = [
    t('takeaways.items.01'),
    t('takeaways.items.02'),
    t('takeaways.items.03'),
    t('takeaways.items.04'),
    t('takeaways.items.05'),
    t('takeaways.items.06'),
    t('takeaways.items.07'),
    t('takeaways.items.08')
  ]

  const getContent = () => (
    <Box sx={{ width: '100%' }}>
      <SectionHeader
        eyebrow={t('takeaways.eyebrow')}
        title={t('takeaways.title')}
        intro={[t('takeaways.intro')]}
      />

      <BulletGrid items={items} columns={2} />
    </Box>
  )

  // *** MAIN RENDER ***
  return (
    <Section
      background={themeColors.kroemtech.background}
      paddingTop="5rem"
      paddingBottom="5rem"
      content={getContent()}
    />
  )
}
